<template>
  <div>
    <small
      v-if="show"
      data-bv-validator="notEmpty"
      :data-bv-validator-for="name"
      class="help-block"
    >
      <span class="is-danger">
        <font-awesome-icon :icon="'exclamation-triangle'" />
        {{ erro }}
      </span>
    </small>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    erro: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/MensagemErro.vue